(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["home-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    function ready(fn) {
      if (document.readyState !== 'loading') fn();
      else document.addEventListener('DOMContentLoaded', fn);
    }

    function initLazyFade() {
      document.querySelectorAll('.nordic-hero__bg-img').forEach(function (img) {
        if (img.complete && img.naturalWidth > 0) {
          img.classList.add('is-loaded');
        } else {
          img.addEventListener('load', function () {
            img.classList.add('is-loaded');
          });
          img.addEventListener('error', function () {
            img.style.display = 'none';
          });
        }
      });
    }

    function initScrollIndicator() {
      document.querySelectorAll('.nordic-hero__scroll-indicator[data-scroll-down]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var section = btn.closest('section');
          var nextEl = section && section.nextElementSibling;
          if (nextEl) nextEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
          else window.scrollBy({ top: window.innerHeight * 0.8, behavior: 'smooth' });
        });
      });
    }

    function initVisibilityPause() {
      document.addEventListener('visibilitychange', function () {
        document.querySelectorAll('.nordic-hero__scroll-indicator').forEach(function (el) {
          el.style.animationPlayState = document.hidden ? 'paused' : 'running';
        });
      });
    }

    ready(function () {
      initLazyFade();
      initScrollIndicator();
      initVisibilityPause();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
